import React from "react";

const menuItems = [
  {
    label: "Master Prompt",
    value: "masterPrompt",
  },
  // {
  //   label: "Organizations",
  //   value: "organizations",
  //   subItems: [
  //     {
  //       label: "Arizona TAP",
  //       value: "arizonaTap",
  //     },
  //     {
  //       label: "Arkansas TAP",
  //       value: "arkansasTap",
  //     },
  //     {
  //       label: "Indiana EE/BPC",
  //       value: "indianaEeBpc",
  //     },
  //     {
  //       label: "Indiana TAP",
  //       value: "indianaTap",
  //     },
  //     {
  //       label: "NIET PREP",
  //       value: "nietPrep",
  //     },
  //     {
  //       label: "NIET Test Organization",
  //       value: "nietTestOrganization",
  //     },
  //     {
  //       label: "Tennessee EE/BPC",
  //       value: "tennesseeEeBpc",
  //     },
  //   ],
  // },
  {
    label: "Enhanced Search Content",
    value: "content",
  },
  {
    label: "Admin Review",
    value: "history",
  },
  {
    label: "Playground",
    value: "playground",
  },
  {
    label: "Enhanced Search Settings",
    value: "settings",
  },
];

export default function VirtualLibrarianMgmtMenu({
  onMenuItemSelected,
  selectedMenuItem,
  selectedOrganization,
}) {
  const handleMenuItemSelected = (value, organization) => {
    onMenuItemSelected(value, organization);
  };

  console.log(selectedOrganization);

  return (
    <div className="sidebar-navigation">
      <h4>Enhanced Search Management</h4>
      {menuItems.map((item) =>
        item?.subItems ? (
          <div className="vl-mgmt-org-container" key={item.value}>
            <button
              onClick={() => handleMenuItemSelected(item.value)}
              className={`vl-mgmt-menu-item${
                selectedMenuItem === item.value ? " active" : ""
              }`}
            >
              {item.label}
            </button>
            <div className="org-list">
              {item.subItems.map((subItem) => (
                <button
                  key={subItem.value}
                  onClick={() => handleMenuItemSelected(item.value, subItem)}
                  className={`org-list-item${
                    subItem.value === selectedOrganization?.value
                      ? " active"
                      : ""
                  }`}
                >
                  {subItem.label}
                </button>
              ))}
            </div>
          </div>
        ) : (
          <button
            key={item.value}
            onClick={() => handleMenuItemSelected(item.value)}
            className={`vl-mgmt-menu-item${
              selectedMenuItem === item.value ? " active" : ""
            }`}
          >
            {item.label}
          </button>
        )
      )}
    </div>
  );
}
